<template>
  <div>
    <v-card class="pa-2" flat :loading="loading">
      <!-- valid: {{ formValid }} -->

      <!-- <v-btn
        x-small
        rounded
        text
        @click="addEmptyRow()"
        v-if="localEditMode"
        class="mb-2"
        ><v-icon x-small color="green" class="mr-2">mdi-plus-circle</v-icon> Add
        new package option</v-btn
      > -->
      <div v-for="(row, index) in prices" :key="index">
        <set-brand-price-row
          v-if="prices[index].active"
          :boxSizes="boxSizes"
          :initialQuantity="row.quantity"
          :initialRetail="row.retail"
          :index="index"
          :editMode="localEditMode"
          :showRemoveBtn="activePriceCount > 1"
          :showAddBtn="lastActiveIndex == index"
          @disable="prices[index].active = 0"
          @addRow="addEmptyRow()"
          @update="updateRow(index, $event)"
        ></set-brand-price-row>
      </div>

      <v-alert
        v-if="dupeAlert"
        type="warning"
        border="left"
        text
        colored-border
        transition="scale-transition"
        class="my-4"
        >{{ dupeAlert }}</v-alert
      >

      <online-price-summary
        :scrapedPrices="scrapedPrices"
        class="mt-4"
      ></online-price-summary>

      <div>
        <v-btn
          x-small
          text
          @click="localEditMode = true"
          v-if="showEdit && !localEditMode"
          color="primary"
          ><v-icon small class="mr-2">mdi-pencil</v-icon> edit</v-btn
        >

        <div v-if="showEdit && localEditMode" class="d-flex flex-row mt-4">
          <v-spacer></v-spacer>
          <v-btn small depressed class="mx-2" @click="doCancel()">
            cancel</v-btn
          >
          <v-btn
            small
            depressed
            color="success"
            class="mx-2"
            @click="doSave()"
            :disabled="!canSave"
            ><v-icon small class="mr-2">mdi-content-save</v-icon> save</v-btn
          >
        </div>
      </div>
      <!-- {{ pricesToUpdate }} -->
    </v-card>
    <v-snackbar v-model="errorSnack" :timeout="2000" color="alert"></v-snackbar>
    <v-snackbar v-model="successSnack" :timeout="2000" color="success"
      ><div v-html="successMsg"></div>
    </v-snackbar>
  </div>
</template>

<script>
import SetBrandPriceRow from "./SetBrandPriceRow.vue";
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";
// import Name from "../dir/file";

export default {
  components: {
    SetBrandPriceRow,
    OnlinePriceSummary: () => import("@/components/clStuff/OnlinePriceSummary"),
  },
  mixins: [UserMixin],
  name: "SetBrandPrice",
  props: {
    existingPrices: null,
    showEdit: {
      type: Boolean,
      default: true,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    title: null,
    lens_id: null,
    lens_name: null,
  },
  data: function () {
    return {
      localEditMode: true,
      formValid: true,
      loading: false,
      boxSizes: [1, 2, 4, 6, 12, 24, 30, 90],
      // showOnline: false,
      emptyRow: {
        id: null,
        quantity: null,
        retail: null,
        original: 0,
        active: 1,
        valid: 1,
        index: 0,
      },
      originalPrices: [],
      prices: [],
      updates: null,
      errorSnack: null,
      successSnack: null,
      successMsg: null,
      errorMsg: null,
    };
  },
  methods: {
    // copy by value
    getObjCopy(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    getEmptyRow() {
      return this.getObjCopy(this.emptyRow); // JSON.parse(JSON.stringify(this.emptyRow));
    },
    addEmptyRow() {
      let row = this.getEmptyRow();
      let priceCount = this.prices.length || 0;
      row.index = priceCount++;
      this.prices.push(row);
    },
    updateRow(index, obj) {
      // console.log("obj", obj);
      let keys = Object.keys(obj);
      let prices = this.prices;
      let valid = true;
      keys.forEach((key) => {
        let val = obj[key] || null;
        prices[index][key] = val;
        if (key == "valid") valid = valid && val;
      });
      this.formValid = valid;
      // console.log(this.prices);
    },
    doCancel() {
      // if (this.showEdit && this.localEditMode) this.localEditMode = false;
      this.$emit("dismiss"); // if this component is embedded in a dialog,
    },

    doSave() {
      let data = this.pricesToUpdate;
      let auth = null;
      if (this.auth_credentials) {
        auth = this.auth_credentials;
      } else {
        alert("Please log in to use this feature");
        return;
      }
      // console.log(data);
      if (!this.canSave) return null; // should not be needed if btn disabled

      let payload = { items: data, auth: auth };
      ApiServices.setLensPrices(payload)
        .then((result) => {
          // console.log(result.data);
          if (result.data.errors) {
            //console.log(result.data.errors);
            this.errorMsg = result.data.errors.join("<br> ");
            this.errorSnack = true;
          } else {
            this.successMsg = "Successfully updated prices";
            this.successSnack = true;
            this.$emit("priceDataChange", result.data.result[this.lens_id]);
            this.$emit("dismiss"); // if
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      // if success
      //this.$emit("dismiss"); // if this component is embedded in a dialog
    },
    setPricesFromExisting() {
      let prices = [];
      if (this.existingPrices?.practice?.boxes) {
        let boxes = this.existingPrices.practice.boxes;
        let boxKeys = Object.keys(boxes);
        let index = 0;
        boxKeys.forEach((box) => {
          let q = boxes[box].quantity || null;
          let r = boxes[box].retail || null;
          if (q && r) {
            let obj = this.getEmptyRow();
            obj.quantity = parseInt(q);
            obj.retail = parseFloat(r);
            obj.original = 1;
            obj.index = index;
            prices.push(obj);
            index++;
          }
        });

        this.prices = prices;
      }
      this.originalPrices = this.getObjCopy(this.prices);
      if (!this.prices.length) this.addEmptyRow();
    },
    setQuantitiesFromExisting() {
      if (this.existingPrices?.meta?.quantities)
        this.boxSizes = this.existingPrices.meta.quantities;
    },
    // takes an array of prices and returns an object where the quantities are  keys
    pricesObjByQuantity(prices) {
      let rtn = {};
      prices.forEach((row) => {
        let key = `${parseInt(row.quantity)}`;
        rtn[key] = row;
      });
      return rtn;
    },
  },
  computed: {
    canSave: function () {
      let updates = this.pricesToUpdate;
      if (!updates) return false;
      return (
        (updates.add && updates.add.length) ||
        (updates.update && updates.update.length)
      );
    },
    scrapedPrices: function () {
      return this.existingPrices?.online;
    },
    activePrices: function () {
      return this.prices.filter((val) => val.active);
    },
    activePopulatedPrices: function () {
      return this.activePrices.filter((val) => {
        return val.retail > 0 && val.quantity > 0;
      });
    },
    activePriceCount: function () {
      return this.activePrices.length;
    },
    lastActiveIndex: function () {
      return this.activePrices[this.activePriceCount - 1].index;
    },
    // deletedPrices: function () {
    //   return this.prices.filter((val) => !val.active && val.original);
    // },
    pricesToUpdate: function () {
      let rtn = { add: [], update: [] };

      let priceObjs = this.pricesObjByQuantity(this.activePopulatedPrices);
      let originalObjs = this.pricesObjByQuantity(this.originalPrices);
      if (!priceObjs) return null;
      let qtys = Object.keys(priceObjs);
      qtys.forEach((q) => {
        priceObjs[q].lens_id = parseInt(this.lens_id);
        priceObjs[q].lens_name = this.lens_name;
        if (!(q in originalObjs)) {
          rtn.add.push(priceObjs[q]);
        } else {
          let price = priceObjs[q];
          let orig = originalObjs[q];
          let samePrice = +price.retail == +orig.retail;
          let sameQuantity = +price.quantity == +orig.quantity;
          let sameActive = price.active == orig.active;
          if (!samePrice || !sameQuantity || !sameActive)
            rtn.update.push(price);
        }
      });
      // todo - find any original prices that have been inactivated
      for (let [qty, row] of Object.entries(originalObjs)) {
        if (!qtys.includes(qty)) {
          row.active = 0;
          row.lens_id = parseInt(this.lens_id);
          row.lens_name = this.lens_name;
          rtn.update.push(row);
        }
      }
      return rtn;
    },
    // see if someone is entering a price for the same quantity (eg setting price for a 90 pack twice)
    duplicateQuantities: function () {
      let allQtys = [];
      let duplicated = null;
      this.activePrices.forEach((val) => {
        let qty = val.quantity;
        if (qty && allQtys.includes(qty)) {
          duplicated = qty;
        } else if (qty) {
          allQtys.push(qty);
        }
      });
      return duplicated;
    },
    dupeAlert: function () {
      let rtn = null;
      if (this.duplicateQuantities) {
        let q = this.duplicateQuantities;
        // let txt = this.duplicateQuantities;
        let txt = q == 1 ? "a single lens" : q + " pack";
        rtn = `Only one price will be saved for each package size (you are recording a duplicate price for a ${txt})`;
      }
      return rtn;
    },
  },

  mounted() {
    if (this.editMode) this.localEditMode = this.editMode;
    this.setPricesFromExisting();
    this.setQuantitiesFromExisting();
  },
};
</script>

<style scoped></style>
